module.exports = __webpack_public_path__ + "static/img/3fed7836-e7fe-405e-b4c8-665b702dee26.26f42f41.png";